import { Relationships } from '..';

import { RawRelationships } from './types';

export const findChampion = (relationships: RawRelationships) => {
	const rawCampionData = relationships?.find((rel) => rel.type === 'FAST_SHIFT_CHAMPION');
	return rawCampionData
		? {
				...rawCampionData,
				title: 'Fastshift Champion',
			}
		: undefined;
};

export const findAccountExecutive = (relationships: RawRelationships) => {
	return relationships?.find((rel) => rel.type === 'ACCOUNT_EXECUTIVE');
};

export const findCustomerSuccessManager = (relationships: RawRelationships) => {
	return relationships?.find((rel) => rel.type === 'CUSTOMER_SUCCESS_MANAGER');
};

export const filterEngineers = (relationships: RawRelationships) => {
	return (
		relationships
			?.filter((rel) => rel.type === 'MIGRATION_SUPPORT_ENGINEER')
			.map(({ name, imageUrl }, index) => ({
				id: `${name}-${index}`,
				name,
				title: 'Migration Support Engineer',
				imageUrl,
			})) || []
	);
};

export const mapRelationships = (relationships: RawRelationships): Relationships => {
	const champion = findChampion(relationships);

	return {
		fastshiftChampion: champion ? { ...champion, title: 'Fastshift Champion' } : undefined,
		accountExecutive: findAccountExecutive(relationships),
		customerSuccessManager: findCustomerSuccessManager(relationships),
	};
};

/**
 * Determines if a support request is open (not closed or done)
 * TODO: To update with proper status check once confirmed
 */
export const isSupportRequestOpen = (status: string): boolean => {
	const upperStatus = status.toUpperCase();
	return upperStatus !== 'CLOSED' && upperStatus !== 'DONE' && upperStatus !== 'COMPLETED';
};
